var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "page",
      staticClass: "addMovie-page",
      on: { scroll: _vm.handlePageScroll },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "movie-average as-flex flex-vertical main-center cross-center",
        },
        [
          _c("div", { staticClass: "movie-average-box as-flex" }, [
            _c(
              "div",
              {
                class: [
                  "movie",
                  "f-3 ",
                  "as-flex",
                  "main-center",
                  "cross-center ",
                  _vm.searchMethod === "movies" ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeMovieAverage("movies")
                  },
                },
              },
              [_vm._v("影片")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "average",
                  "f-3 ",
                  "as-flex",
                  "main-center",
                  "cross-center ",
                  _vm.searchMethod === "average" ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeMovieAverage("average")
                  },
                },
              },
              [_vm._v("均值")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fixed-search-bar as-flex main-center cross-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "f-3 search-btn as-flex main-center cross-center",
                },
                [
                  _c("img", {
                    staticClass: "search-img",
                    attrs: {
                      src: require("../../assets/images/search-3x.png"),
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchInfo,
                        expression: "searchInfo",
                      },
                    ],
                    staticClass: "search-placeholder f-2 fc-gray-2",
                    attrs: { placeholder: "搜索影片" },
                    domProps: { value: _vm.searchInfo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchInfo = $event.target.value
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.searchMethod === "movies"
        ? _c("div", { staticClass: "movie-box" }, [
            _c(
              "div",
              { staticClass: "filter-box" },
              [
                _c("folderFilterBox", {
                  key: "normal",
                  ref: "filterBox",
                  attrs: {
                    filterTypesModel: _vm.filterTypes,
                    showDetailSearch: true,
                    currentFilterFlag: _vm.currentFilter,
                  },
                  on: { executeFilter: _vm.recieveFilterChange },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "listContainer", class: ["list-container", "f-3"] },
              [
                _vm.movieList && _vm.movieList.length > 0
                  ? _c(
                      "div",
                      { ref: "scrollContainer" },
                      [
                        _vm._l(_vm.movieList, function (item) {
                          return item.movie && item.movie.id
                            ? [
                                _c(
                                  "div",
                                  {
                                    key: "movie_" + item.movie.id,
                                    staticClass: "movie-box-container",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleCurrentChosenMovies({
                                          id: item.movie.id,
                                          title: item.movie_name,
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("movieBox", {
                                      attrs: {
                                        movieInfo: item,
                                        type: "multi",
                                        chosen:
                                          _vm.currrentChosenMovies.indexOf(
                                            item.movie.id
                                          ) >= 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e()
                        }),
                      ],
                      2
                    )
                  : void 0,
              ],
              2
            ),
          ])
        : _c(
            "div",
            {
              staticClass:
                "average-box as-flex flex-vertical main-start cross-start f-2",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "filter-row movie-tags as-flex main-start cross-start",
                },
                [
                  _c("div", { staticClass: "tag-title" }, [_vm._v("标签")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tag-list as-flex main-start cross-center" },
                    [
                      _vm._l(_vm.filterTags, function (item) {
                        return [
                          _c(
                            "span",
                            {
                              key: item.id,
                              ref: item.value + item.id,
                              refInFor: true,
                              class: [
                                _vm.currentFilter.tags.includes(item.id)
                                  ? "is-filter-active"
                                  : "",
                                "f-2",
                                "list-item",
                                item.is_allowed
                                  ? "is-allowed"
                                  : "is-not-allowed",
                                "as-flex",
                                "flex-horizontal",
                                "main-center",
                                "cross-center",
                              ],
                              on: {
                                click: function ($event) {
                                  item.is_allowed
                                    ? _vm.multiSelectFilter("tags", item)
                                    : function () {}
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "filter-row movie-locations as-flex main-start cross-start",
                },
                [
                  _c("div", { staticClass: "tag-title" }, [_vm._v("地区")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tag-list as-flex main-start cross-center" },
                    [
                      _vm._l(_vm.filterDistricts, function (item) {
                        return [
                          _c(
                            "span",
                            {
                              key: item.id,
                              ref: item.value + item.id,
                              refInFor: true,
                              class: [
                                _vm.currentFilter.location.includes(item.id)
                                  ? "is-filter-active"
                                  : "",
                                "f-2",
                                "list-item",
                                item.is_allowed
                                  ? "is-allowed"
                                  : "is-not-allowed",
                                "as-flex",
                                "flex-horizontal",
                                "main-center",
                                "cross-center",
                              ],
                              on: {
                                click: function ($event) {
                                  item.is_allowed
                                    ? _vm.multiSelectFilter("location", item)
                                    : function () {}
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "filter-row movie-year as-flex main-start cross-start",
                },
                [
                  _c("div", { staticClass: "tag-title" }, [_vm._v("年份")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tag-list as-flex main-start cross-center" },
                    [
                      _vm._l(_vm.filterYears, function (item) {
                        return [
                          _c(
                            "span",
                            {
                              key: item.id,
                              ref: item.value + item.id,
                              refInFor: true,
                              class: [
                                _vm.currentFilter.year.includes(item.id)
                                  ? "is-filter-active"
                                  : "",
                                "f-2",
                                "list-item",
                                item.is_allowed
                                  ? "is-allowed"
                                  : "is-not-allowed",
                                "as-flex",
                                "flex-horizontal",
                                "main-center",
                                "cross-center",
                              ],
                              on: {
                                click: function ($event) {
                                  item.is_allowed
                                    ? _vm.multiSelectFilter("year", item)
                                    : function () {}
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "multi-bubble bubble-confirm as-flex flex-vertical main-center cross-center f-2",
          on: {
            click: function ($event) {
              return _vm.changeMultiStatus(true)
            },
          },
        },
        [
          _vm.searchMethod === "movies"
            ? [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.currrentChosenMovies.length === 0
                        ? "多选"
                        : _vm.currrentChosenMovies.length + "部"
                    )
                  ),
                ]),
              ]
            : [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.averageInfo.id && _vm.averageInfo.count > 0
                        ? _vm.averageInfo.count + "部"
                        : "多选"
                    )
                  ),
                ]),
              ],
          _vm._v(" "),
          _c("span", [_vm._v("对比")]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }